class AblyTransmitter {

    static transmit({ nick_name, namespace, room_key, action }) {
        let channel = window.Ably.channels.get(this.channelName(namespace, room_key));
        let payload = { sender_nick_name: nick_name, action: action };
        // console.log("Publishing ", this.channelName(namespace, room_key), "--> ", payload);
        channel.publish(namespace,payload);  //namespace is used both for channel name and message name
    }

    // //TODO: Refactor from AblyReceiver.
    static channelName(namespace, key) {
		return (namespace + ":room_" + key);
	}
}

export default AblyTransmitter;